import { render, staticRenderFns } from "./noAxis.md?vue&type=template&id=dd54a410&"
import script from "./noAxis.md?vue&type=script&lang=js&"
export * from "./noAxis.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd54a410')) {
      api.createRecord('dd54a410', component.options)
    } else {
      api.reload('dd54a410', component.options)
    }
    module.hot.accept("./noAxis.md?vue&type=template&id=dd54a410&", function () {
      api.rerender('dd54a410', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/bar/noAxis.md"
export default component.exports